import { render, staticRenderFns } from "./WitnessTimeListView.vue?vue&type=template&id=03875ec4&"
import script from "./WitnessTimeListView.vue?vue&type=script&lang=js&"
export * from "./WitnessTimeListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports